import { useQuery } from "@tanstack/react-query";
import type { TimeRange } from "../models";
import { getOperationsTimeline } from "../repositories/OperationsTimelineRepository";

export function useOperationsTimeline(range: TimeRange) {
	return useQuery({
		queryKey: ["operationsTimeline", range.start, range.end],
		queryFn: ({ signal }) => getOperationsTimeline(range, signal),
		refetchOnWindowFocus: false,
		staleTime: 30_000,
		retry: false,
	});
}
